/**
 * jQuery railsRemote
 *
 * Copyright (c) 2011 Ca-Phun Ung <caphun at yelotofu dot com>
 * Licensed under the MIT (MIT-LICENSE.txt) license.
 *
 * http://github.com/caphun/jquery.railsremote/
 *
 * Plugin to handle Rails remote forms.
 *
 */
(function(factory){
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else {
        factory(jQuery);
    }
}(function($){

  $.fn.railsRemote = function( options ) {
    var self = this;
    return self.each(function() {
      new $.railsRemote(this, options);
    });
  };

  $.railsRemote = function(elem, options) {
    this.options = $.extend(true, {}, $.railsRemote.defaults, options );
    this.element = $(elem);
    this.init();
  };

  $.railsRemote.defaults = {
    objName: function() {
      return this.id.replace(/(^new_|^edit_|_\d+$)/g,'');
    },
    errorClass: 'inline-errors',
    errorIdSuffix: '_inline_error',
    errorFormat: '<span>{MSG}</span>',
    thankYouMsg: 'Thank You!',
    'after?': true,
    success: function(){},
    error: function(){}
  };

  $.railsRemote.prototype = {
    init: function() {
      var self = this.element,
          o = this.options,
          objName = $.isFunction(o.objName) ? o.objName.call(this.element[0]) : o.objName,
          attrRemote = self.attr('data-remote');

      if (typeof attrRemote == 'undefined' || attrRemote === false) {
        self.attr('data-remote', true);
        self.attr('action', function(i, val) {
          return val + '.json';
        });
      }

      self.bind('ajax:complete', function(event, xhr, status){
        $('.'+ o.errorClass, self).empty();

        try {
          var data = $.parseJSON(xhr.responseText).errors;
        } catch (e) {
          var data = [];
        }

        if (status === 'error') {

          $.each(data, function(key, value) {
            var selector = objName + '_' + key,
                msg = value[0] || value,
                inlineErrorId = selector + o.errorIdSuffix;

            // format message
            msg = o.errorFormat.replace('{MSG}', msg);

            if ($('#'+inlineErrorId).length) {
              $('#'+inlineErrorId).html(msg);
            } else {
              //$('<span id="'+ inlineErrorId +'" class="'+ o.errorClass +'">' + msg + '</span>')['insert' + (o['after?'] ? 'After':'Before')]('#' + selector);
              $(msg).attr('id', inlineErrorId).addClass(o.errorClass)['insert' + (o['after?'] ? 'After':'Before')]('#' + selector);
            }

            o.error(data, inlineErrorId, xhr);
          });
        }
        if (status === 'success') {
          if(o.thankYouMsg) self.hide().after('<p>'+ o.thankYouMsg +'</p>');
          o.success(data, xhr);
        }
      });
    }
  };
}));
